import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {catchError, Observable, of} from 'rxjs';
import {environment} from '../../../environments/environment';
import {ForecastStand, StandAbfrage} from '../../model/forecast-stand.model';

/**
 * Fragt `POST forecast/stand`: welche Vorhersagepakete (Sammlungen der Wetterdaten-API) die
 * gemeldeten Boxen benutzt haben, mit wie vielen Stationen und von wann deren Einträge im
 * Cache des Rest-Service sind. Der Rumpf nennt je gefüllter Box Reihe und Ort; der Service
 * löst Region → Station und Reihe → Sammlungen auf. Bewusst ohne Cache – wird je Knopfdruck
 * "MSWR-MOS laden" einmal gefragt und soll den aktuellen Stand zeigen.
 */
@Injectable({providedIn: 'root'})
export class ForecastStandService {

  constructor(private http: HttpClient) {
  }

  /** Der Stand für diese Boxen, oder null wenn der Endpunkt nicht antwortet (älterer Server). */
  lade(abfragen: StandAbfrage[]): Observable<ForecastStand | null> {
    return this.http.post<ForecastStand>(`${environment.terminalApiUrl}/forecast/stand`, {abfragen}).pipe(
      catchError(err => {
        console.warn(`Stand der Vorhersage-Caches nicht abrufbar (Status ${err?.status}).`);
        return of(null);
      })
    );
  }
}
